import { fetchData, apiURL } from './api_helper';

const getSearchConfig = (reqBody, authTokenReq) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/api/library/searchConfig`;
    fetchData(endpointURL, 'GET', reqBody, authTokenReq)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });

const search = (config, authTokenReq) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/api/library/search`;
    fetchData(endpointURL, 'POST', config, authTokenReq)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });

const getResultByPage = (config, sectionId, page) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/api/library/search/${sectionId}/${page}`;
    fetchData(endpointURL, 'POST', config)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });

const getThematics = classId =>
  new Promise((resolve, reject) => {
    let endpointURL;
    if (classId) {
      endpointURL = `${apiURL}/api/library/thematicList/${classId}`;
    } else {
      endpointURL = `${apiURL}/api/library/thematicList`;
    }
    fetchData(endpointURL, 'GET')
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });

const getThematicLessons = thematicId =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/api/library/thematics/${thematicId}`;
    fetchData(endpointURL, 'GET', thematicId)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });

const getCatalogueCategories = () =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/api/library/catalogue`;
    fetchData(endpointURL, 'GET')
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });

const getCatalogueLessons = catalogueId =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/api/library/catalogue/${catalogueId}`;
    fetchData(endpointURL, 'GET', catalogueId)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });

const getVocabularyCategories = requestParams =>
  new Promise((resolve, reject) => {
    let endpointURL = `${apiURL}/api/library/vocabularyCategoryList`;
    if (requestParams && requestParams.term) {
      endpointURL += `?term=${requestParams.term}`;
    }
    fetchData(endpointURL, 'GET')
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });

const getVocabularyCategoriesV2 = requestParams =>
  new Promise((resolve, reject) => {
    let endpointURL = `${apiURL}/api/library/v2/vocabularyCategoryList`;
    if (requestParams && requestParams.term) {
      endpointURL += `?term=${requestParams.term}`;
    }
    fetchData(endpointURL, 'GET')
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });

const getVocabularyList = requestParams =>
  new Promise((resolve, reject) => {
    let endpointURL = `${apiURL}/api/library/vocabularyList`;
    if (
      !(requestParams.categoryId == null || requestParams.categoryId == -1)
    ) {
      endpointURL += `/${requestParams.categoryId}`;
    }
    endpointURL += `?page=${requestParams.page}`;
    if (requestParams.term) {
      endpointURL += `&term=${requestParams.term}`;
    }
    fetchData(endpointURL, 'GET')
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });

const getChatbotCategories = () =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/api/library/chatbot`;
    fetchData(endpointURL, 'GET')
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });

const getChatbotLessons = chatbotId =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/api/library/chatbot/${chatbotId}`;
    fetchData(endpointURL, 'GET', chatbotId)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });

const getGrammarCategories = () =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/api/library/grammar`;
    fetchData(endpointURL, 'GET')
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });

const getGrammarLessons = grammarId =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/api/library/grammar/${grammarId}`;
    fetchData(endpointURL, 'GET')
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });

const getBonusLessonByLevel = level =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/api/library/bonusList/${level}`;
    fetchData(endpointURL, 'GET')
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });

export default {
  getSearchConfig,
  search,
  getResultByPage,
  getThematics,
  getThematicLessons,
  getCatalogueCategories,
  getCatalogueLessons,
  getVocabularyCategories,
  getVocabularyList,
  getChatbotCategories,
  getChatbotLessons,
  getGrammarCategories,
  getGrammarLessons,
  getBonusLessonByLevel,
  getVocabularyCategoriesV2
};



// WEBPACK FOOTER //
// ./src/api/exercises.js